import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["db-icon"]
const _hoisted_4 = { class: "h-10 w-10 mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "bg-white shadow-lg max-h-[400px] h-auto overflow-auto"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["innerHTML"]

import { onMounted, ref } from "vue";
import { DbIcon, DbInput } from "@db-ui/v-elements-enterprise/dist/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  props: {
  modelValue: {
    default: "",
  },
  placeholder: {
    default: "",
  },
  disabled: {
    default: false,
  },
  hasError: {
    default: false,
  },
  name: {
    default: "",
    required: false,
  },
  label: {
    default: "",
    required: false,
  },
  options: {
    default: [],
    required: false,
  },
  icon: {
    default: "",
    required: false,
  },
  errorMessage: {
    default: "",
    required: false,
  },
},
  emits: ["onSelect", "update:modelValue"],
  setup(__props, { emit: __emit }) {

const input = ref("");
const showSuggestions = ref(false);
const filteredSuggestions = ref([]);
const autocompleteRef = ref("");
const emit = __emit;
const props = __props;

const showClearIcon = ref(false);

const selectSuggestion = (suggestion: string) => {
  emit("update:modelValue", suggestion);
  showSuggestions.value = false;
  emit("onSelect", suggestion);
};
const transformString = (v: string) => v.toLowerCase().replace(" ", "");

const valueChange = (value: string) => {
  filteredSuggestions.value = props.options.filter((option) => {
    return transformString(option).includes(transformString(String(value)));
  });

  showClearIcon.value = value.length > 0;
  showSuggestions.value =
    filteredSuggestions.value.length > 0 && value.length > 2;
};

const closeSuggestionsIfClickedOutside = (event) => {
  if (autocompleteRef.value && !autocompleteRef.value.contains(event.target)) {
    showSuggestions.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", closeSuggestionsIfClickedOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DbInput), {
        label: __props.label,
        name: __props.name,
        disabled: __props.disabled,
        placeholder: __props.placeholder,
        value: __props.modelValue,
        class: "hydrated w-full",
        variant: "semitransparent",
        onInput: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.$emit('update:modelValue', $event.target.value);
          valueChange($event.target.value);
        }),
        ref_key: "input",
        ref: input
      }, null, 8, ["label", "name", "disabled", "placeholder", "value"]),
      (showClearIcon.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "db-icon cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
          _ctx.$emit('update:modelValue', '');
          valueChange('');
          _ctx.$emit('onSelect', '');
        }),
            "db-icon": __props.icon
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(DbIcon), {
                icon: __props.icon,
                variant: "24-outline"
              }, null, 8, ["icon"])
            ])
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "absolute z-10 w-[240px]",
      ref_key: "autocompleteRef",
      ref: autocompleteRef
    }, [
      (showSuggestions.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSuggestions.value, (suggestion) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "py-2 px-2 hover:bg-gray-100",
                key: suggestion,
                onClick: ($event: any) => (selectSuggestion(suggestion))
              }, _toDisplayString(suggestion), 9, _hoisted_6))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
          _createElementVNode("p", {
            class: "showError",
            innerHTML: __props.errorMessage
          }, null, 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})